export type SupplierTab =
  | 'overview'
  | 'performance'
  | 'agreements'
  | 'risk'
  | 'profile';

export const SUPPLIER_TABS: { value: SupplierTab; label: string }[] = [
  { value: 'overview', label: 'Overview' },
  { value: 'performance', label: 'Performance' },
  { value: 'agreements', label: 'Agreements' },
  { value: 'risk', label: 'Risk' },
  { value: 'profile', label: 'Company details' },
];

export function isSupplierTab(value: string): value is SupplierTab {
  return SUPPLIER_TABS.some((tab) => tab.value === value);
}
